
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["activityManage_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M848.704 985.088a32.32 32.32 0 01-22.656-9.344l-91.84-91.84-88.512 88.512a32 32 0 01-45.248 0L512 883.904l-90.24 90.24a32 32 0 01-45.248 0l-90.304-90.24-91.008 90.944a31.488 31.488 0 01-32.448 7.808 96.128 96.128 0 01-67.072-91.712V135.488a96.64 96.64 0 0196.576-96.576h639.552c53.248 0 96.64 43.328 96.64 96.576v755.52c0 43.264-29.312 81.408-71.232 92.928a32.448 32.448 0 01-8.512 1.152zM734.272 806.656A32.142 32.142 0 01756.928 816l97.856 97.856a32.192 32.192 0 009.6-22.848v-755.52a32.64 32.64 0 00-32.64-32.576H192.192a32.64 32.64 0 00-32.576 32.576v755.52c0 7.936 2.88 15.296 7.872 20.992l96-96a32 32 0 0145.248 0l90.304 90.24L489.28 816a32 32 0 0145.248 0l88.512 88.512L711.552 816a32.128 32.128 0 0122.72-9.344z"}}),_c('path',{attrs:{"d":"M707.52 330.944H310.912a32 32 0 010-64h396.544a32 32 0 01.064 64zm0 153.088H310.912a32 32 0 010-64h396.544a32 32 0 01.064 64zm0 153.024H310.912a32 32 0 010-64h396.544a32 32 0 01.064 64z"}})])
          )
        }
      }
    